import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Batches from "../../components/Batches/Batches";


const BatchesListPage = () => {
  return (
    <>

  

        {/* Breadcrumb */}
        

        {/* UsersListLayer */}
        <Batches />


    </>
  );
};

export default BatchesListPage; 
